import licenseModule from '../../license.module';
import template from './licenseOverview.component.html';
import style from './licenseOverview.component.css';

export default licenseModule.component('licenseOverview', {
    template,
    style,
    controller: licenseOverviewComponent,
    bindToController: true
});

function licenseOverviewComponent(
    asLoadingMask,
    asNotifier,
    LicenseOverviewService,
    LicenseManagementService,
    textResources
) {
    var vm = this;
    vm.$onInit = activate;
    asLoadingMask.show();
    vm.overview = {
        billingContactInformation: null,
        cloudSubscriptionSummary: null,
        purchasesHistory: null,
        appspaceIdSummary: null,
        licenseTypes: null,
        licenseTypeUsage: null
    };

    function activate() {
        // get the billing contact information
        LicenseOverviewService.getBillingContactInformation().then(
            function(data) {
                vm.overview.billingContactInformation = data;
            },
            function() {
                // handle error
            }
        );

        // get the plan information summary
        LicenseOverviewService.getPlanInfoSummary().then(
            function(data) {
                vm.overview.planInfoSummary = data;
            },
            function() {
                // handle error
            }
        );

        // get the cloud subscription summary
        LicenseOverviewService.getCloudSubscriptionSummary().then(
            function(data) {
                vm.overview.cloudSubscriptionSummary = data;
                if (
                    data.bandwidthDetail &&
                    data.bandwidthDetail.usage == null
                ) {
                    asNotifier.error(
                        textResources.bandwidthUsageRetrievalFailed
                    );
                }
            },
            function() {
                // handle error
            }
        );

        // get the Appspace ID information
        LicenseManagementService.getAppspaceIDSummary().then(
            function(data) {
                vm.overview.appspaceIdSummary = data;
                asLoadingMask.hide();
            },
            function() {
                // handle error
            }
        );

        // get the purchases history
        LicenseOverviewService.getPurchasesHistory().then(
            function(data) {
                vm.overview.purchasesHistory = data;
            },
            function() {}
        );
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-overview/licenseOverview.component.js